import type { GridRenderHeaderFilterProps } from "@mui/x-data-grid-premium";
import type { SelectProps } from "src/components/SelectV2/SelectV2.types.ts";
import { DataGridSelectHeaderFilterImpl } from "src/components/DataGrid/DataGridSelectHeaderFilterImpl.tsx";

export const DataGridSelectHeaderFilter = (
  props: GridRenderHeaderFilterProps &
    Pick<SelectProps<string>, "placeholder" | "allowClearValue">,
) => {
  // this wrapper exists only to fix hot reloading in this component
  return <DataGridSelectHeaderFilterImpl {...props} />;
};
